var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBulkSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23.797,
    viewBox: "0 0 26 23.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M15.2,18.4A5.4,5.4,0,1,1,20.6,23.8,5.4,5.4,0,0,1,15.2,18.4Zm1.08,0A4.319,4.319,0,1,0,20.6,14.08,4.318,4.318,0,0,0,16.282,18.4ZM15.253,23H2a2,2,0,0,1-2-2L.01,4A2,2,0,0,1,2,2H3V0H5V2H21V0h2V2h1a2,2,0,0,1,2,2V14.1a7,7,0,0,0-2-1.427V6H2V21H14.29a6.978,6.978,0,0,0,.964,2v0Zm4.808-4.062V15.7h.81v2.834L23.3,19.976l-.4.664ZM4,19V16H7v3Zm5-3V13h3v3Zm10-5V8h3v3ZM9,11V8h3v3ZM7,11H4V8H7v3H7Z",
    fill: "#0000b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulkSchedule);
export default __webpack_public_path__ + "static/media/icon-bulk-schedule.30ceebaeb0311f000ca3a59e20d4bf74.svg";
export { ForwardRef as ReactComponent };